import { SystemStyleObject } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'

// Font family constant (matches packages/dark/src/theme/semantic/textStyles.ts)
const soehne = "'Soehne', sans-serif"

const tokens = {
  dark: {
    bg: 'bg.action-bar',
    bgHover: 'bg.action-bar-hover',
    bgActive: 'bg.action-bar-active',
    border: 'border.action-bar',
    labelText: 'text.action-bar-label',
    actionText: 'text.action-bar-action',
  },
  light: {
    bg: 'light.bg.action-bar',
    bgHover: 'light.bg.action-bar-hover',
    bgActive: 'light.bg.action-bar-active',
    border: 'light.border.action-bar',
    labelText: 'light.text.action-bar-label',
    actionText: 'light.text.action-bar-action',
  },
}

export const actionBarWrapperStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  height: '44px',
  overflow: 'hidden',
  boxShadow: '0 6px 18px rgba(0,0,0,0.35)',
}

export const selectionSectionStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  px: '16px',
  py: '10px',
  bg: tokens[colorScheme].bg,
  flexShrink: 0,
  borderRight: '1px solid',
  borderColor: tokens[colorScheme].border,
})

export const selectionLabelStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: soehne,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  color: tokens[colorScheme].labelText,
  whiteSpace: 'nowrap',
  userSelect: 'none',
})

export const clearButtonStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: tokens[colorScheme].labelText,
  p: '4px',
  _hover: { color: tokens[colorScheme].actionText },
  transition: 'color 0.15s ease',
})

export const actionSectionStyles = (
  isActive?: boolean,
  colorScheme: ColorScheme = 'dark',
  isDisabled = false
): SystemStyleObject => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  px: '16px',
  py: '10px',
  bg: isActive ? tokens[colorScheme].bgActive : tokens[colorScheme].bg,
  borderRight: '1px solid',
  borderTop: 'none',
  borderBottom: 'none',
  borderLeft: 'none',
  borderColor: tokens[colorScheme].border,
  cursor: isDisabled ? 'not-allowed' : 'pointer',
  color: tokens[colorScheme].actionText,
  flexShrink: 0,
  opacity: isDisabled ? 0.45 : 1,
  _hover: isDisabled
    ? undefined
    : {
        bg: isActive
          ? tokens[colorScheme].bgActive
          : tokens[colorScheme].bgHover,
      },
  _last: {
    borderRight: 'none',
  },
  transition: 'background 0.15s ease',
})

export const actionLabelStyles = (
  colorScheme: ColorScheme = 'dark'
): SystemStyleObject => ({
  fontFamily: soehne,
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  color: tokens[colorScheme].actionText,
  whiteSpace: 'nowrap',
  userSelect: 'none',
})

export const actionIconStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '20px',
  height: '20px',
  p: '2px',
}
